exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ProseMirror-View{overflow-y:scroll}.ProseMirror{padding:10px;background:#fff}.ProseMirror:focus{outline:none}.ProseMirror ol,.ProseMirror ul{padding-left:30px}.ProseMirror blockquote{padding-left:1em;border-left:3px solid #eee;margin-left:0;margin-right:0}.ProseMirror img{cursor:default}.ProseMirror table{width:auto}.ProseMirror td,.ProseMirror th{border:1px solid #eee;padding:2px 5px}.ProseMirror sub,.ProseMirror sup{line-height:0}.ProseMirror label{cursor:auto}", ""]);

// exports
